import comlinkTransferHandler from '../util/comlinkTransferHandler';
import * as Comlink from 'comlink';

class CalculationsWorker {
  id = 0;

  constructor() {
    this.worker = typeof Worker !== 'undefined' ? new Worker('/worker.js', { type: 'module' }) : {};
    this.id = [...Array(8)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
  }

  wrap() {
    return Comlink.wrap(this.worker);
  }

  terminate() {
    this.worker.terminate();
  }
}

export default CalculationsWorker;
